import { useEffect, useCallback } from 'react';

const useKeyboardControls = ({
  onLeft,
  onRight,
  onDown,
  onRotate,
  onDrop,
  onPause,
  enabled = true,
}) => {
  const handleKeyDown = useCallback((e) => {
    if (!enabled) return;

    switch (e.key) {
    case 'ArrowLeft':
    case 'a':
    case 'A':
      e.preventDefault();
      onLeft?.();
      break;
    case 'ArrowRight':
    case 'd':
    case 'D':
      e.preventDefault();
      onRight?.();
      break;
    case 'ArrowDown':
    case 's':
    case 'S':
      e.preventDefault();
      onDown?.();
      break;
    case 'ArrowUp':
    case 'w':
    case 'W':
      e.preventDefault();
      onRotate?.();
      break;
    case ' ':
      e.preventDefault();
      onDrop?.();
      break;
    case 'p':
    case 'P':
    case 'Escape':
      e.preventDefault();
      onPause?.();
      break;
    default:
      break;
    }
  }, [enabled, onLeft, onRight, onDown, onRotate, onDrop, onPause]);

  useEffect(() => {
    if (enabled) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [enabled, handleKeyDown]);
};

export default useKeyboardControls;
